const dateLocale = require('date-fns/locale/pt');

export default {
  dateLocale,
};
